import React, { useState } from 'react'
import * as S from './style'
import ClassSigninIcon from '~images/parent-signup/olzoo.svg'
import SplashLearnLogo from '~images/loggedout/home/logo.png'
import { assetPath } from '../../../../utils/web-helper'

const Header = (props) => {
  const [ showNavBarMenu, setShowNavBarMenu ] = useState(false)

  const classLoginClickHandler = () => {
    typeof trackEventOnGA !== "undefined" && trackEventOnGA('Clicked class code signin', {'From Page': 'from signup page'});
    typeof trackEventOnGA !== "undefined" && trackEventOnGA("Initiated Sign up with",'class code','Student');
    window.top.location = "/student"
  }

  const loginClickHandler = () => {
    window.top.location = "/signin"
  }

  return (
    <div>
      <S.Header id="header">
        <S.Container>
          <S.LeftLogo href="/"><img src={assetPath(SplashLearnLogo)} alt="Logo"/></S.LeftLogo>
          <S.RightMain>
            <S.NavbarButton className="js-btn-navbar collapsed" data-target=".new-nav-collapse" data-toggle="collapse" type="button" onClick={()=>setShowNavBarMenu(prev => !prev)}>
              <S.IconBar className="icon-bar"></S.IconBar>
              <S.IconBar className="icon-bar"></S.IconBar>
              <S.IconBar className="icon-bar"></S.IconBar>
            </S.NavbarButton>
            <S.HeaderButtons showNavBarMenu={showNavBarMenu} className="new-nav-collapse collapse">
              <S.ClassCodeLogin>
                <S.LeftEarIcon src={assetPath(ClassSigninIcon)}/>
                <S.ClassLoginButton onClick={classLoginClickHandler}>Sign in with Class Code</S.ClassLoginButton>
              </S.ClassCodeLogin>
              <S.LoginButton onClick={loginClickHandler}href="/signin">Log in</S.LoginButton>
            </S.HeaderButtons>
          </S.RightMain>
        </S.Container>
      </S.Header>
    </div>
  )
}

export default Header;